var map = {
	"./circle-empty.png": "f52f",
	"./circle-filled.png": "1579",
	"./clinical-symptoms-reported-image-1.png": "53c7",
	"./clipboard-diagnosis.png": "9ffd",
	"./disease-course-and-impact-carousel-1-image.png": "ac7e",
	"./disease-course-and-impact-image-1.png": "716d",
	"./fda-envelope-rounded.png": "af43",
	"./histopathological-analysis-image.png": "9cb0",
	"./lifecycle-of-sars-cov-2-image.png": "1971",
	"./pfizer-medical-logo.png": "edca",
	"./rd-antiviral.png": "9123",
	"./rd-doctor-patient.png": "0d1c",
	"./rd-doctor-result.png": "0235",
	"./rd-fda-screenshot.png": "343d",
	"./rd-greasley.png": "472b",
	"./rd-histopathological.png": "87fb",
	"./rd-histopathology-score.png": "482d",
	"./rd-laboratory-rounded.png": "61ad",
	"./rd-nirmatrelvir-structure.png": "ebaa",
	"./rd-nirmatrelvir.png": "f88d",
	"./rd-pfizer-img.png": "07ae",
	"./sars-cov-2-infection-image.png": "0b425",
	"./vaccine-types-image-left.png": "feaf",
	"./vaccine-types-image-right.png": "5791",
	"./viral-transmission-of-sars-cov-2-image.png": "36cd",
	"./what-are-coronaviruses-carousel-0-image.png": "f7d5",
	"./what-are-coronaviruses-carousel-2-image.png": "43d7",
	"./what-are-coronaviruses-image-0.png": "2f5b",
	"./what-are-coronaviruses-image-2.png": "ddf4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4f06";